// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap[data-v-55b6b76f] {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n.no-data > img[data-v-55b6b76f] {\n  width: 200px;\n}\n.no-data > p[data-v-55b6b76f] {\n  height: 30px;\n  line-height: 40px;\n  text-align: center;\n  color: #999;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
